import { httpClient } from './api';

export interface CreateOrderPayload {
  plannedStartDate?: string; // YYYY-MM-DD
  unterrichtsformId?: number;
}

export interface OrderDTO {
  id: number;
  trialLessonId: number;
  teacherId: number;
  subprofileId?: number | null;
  unterrichtsformId?: number | null;
  plannedStartDate?: string | null;
  status: 'angelegt'|'versendet'|'angenommen'|'abgelehnt'|'bestätigt'|'zurückgezogen'|'beendet';
}
export type OrderStatus = OrderDTO['status'];

export type TeacherOrderListItem = {
  id: number;
  status: OrderStatus;
  plannedStartDate: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  studentName: string;
  fachName: string | null;
  unterrichtsformName: string | null;
  trialLessonId: number | null;
  migrationCaseId: number | null;
  enrollmentId: number | null;
  hasContractPdf: boolean;
};

export interface ConfirmOrderPayload {
  sendTeacherEmail?: boolean;
  sendStudentEmail?: boolean;
  studentEmails?: string[];
  history?: {
    type?: string;
    description?: string;
  };
  /** Bearbeitete Mails je Empfänger; das Backend nimmt sie statt der Vorlage. */
  drafts?: Partial<Record<'student' | 'teacher', { subject?: string; html?: string; text?: string }>>;
  /** Diese Anmeldung gleich mit starten — Kursteilnahme, Kurs, Vertragskonto (T-0293). */
  startCourseEnrollmentId?: number;
}

export async function createOrder(trialId: string | number, payload: CreateOrderPayload): Promise<OrderDTO> {
  const res = await httpClient<OrderDTO>(`/api/trials/${trialId}/orders`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  if (!res.data) throw new Error(res.error || 'Auftrag konnte nicht erstellt werden');
  return res.data;
}

export async function sendOffer(orderId: number, payload: Record<string, unknown> = {}): Promise<OrderDTO> {
  const res = await httpClient<OrderDTO>(`/api/orders/${orderId}/send-offer`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  if (!res.data) throw new Error(res.error || 'Angebot konnte nicht versendet werden');
  return res.data;
}

export async function confirmOrder(orderId: number, payload: ConfirmOrderPayload = {}): Promise<OrderDTO> {
  const res = await httpClient<OrderDTO>(`/api/orders/${orderId}/confirm`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  if (!res.data) throw new Error(res.error || 'Auftrag konnte nicht bestätigt werden');
  return res.data;
}

export async function getOrderDownloadUrl(orderId: number): Promise<string> {
  const res = await httpClient<{ url: string }>(`/api/orders/${orderId}/download-url`);
  if (!res.data) throw new Error(res.error || 'Download-Link nicht verfügbar');
  return res.data.url as string;
}

export async function fetchTeacherOrders(
  personId: number,
  status?: OrderStatus
): Promise<TeacherOrderListItem[]> {
  const query = status ? `?status=${encodeURIComponent(status)}` : '';
  const res = await httpClient<TeacherOrderListItem[]>(`/api/personen/${personId}/orders${query}`);
  if (res.error) throw new Error(res.error);
  return Array.isArray(res.data) ? res.data : [];
}

export async function getLatestOrderForTrial(trialId: string | number): Promise<OrderDTO | null> {
  const res = await httpClient<OrderDTO | null>(`/api/trials/${trialId}/orders/latest`);
  if (res.error) return null;
  return (res.data ?? null) as (OrderDTO | null);
}


